var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Math, article, encodeURIComponent, sd) {
jade_mixins["share"] = jade_interp = function(description, media, url){
var block = (this && this.block), attributes = (this && this.attributes) || {};
url = url || encodeURIComponent(sd.APP_URL + sd.CURRENT_PATH)
description = description || ''
media = media || ''
buf.push("<a data-message=\"Share via email\" data-service=\"email\"" + (jade.attr("href", "mailto:?subject=" + (description) + "&body=Check out " + (description) + " on Artsy: " + (url) + "", true, true)) + " class=\"share-by-email black-tooltip\"><i class=\"icon-mail\"></i></a><a data-message=\"Post to Facebook\" data-service=\"facebook\"" + (jade.attr("href", "https://www.facebook.com/sharer/sharer.php?u=" + (url) + "", true, true)) + " target=\"_blank\" class=\"share-to-facebook black-tooltip\"><i class=\"icon-facebook\"></i></a><a data-message=\"Share on Twitter\" data-service=\"twitter\"" + (jade.attr("href", "https://twitter.com/intent/tweet?original_referer=" + (url) + "&text=" + (description) + "&url=" + (url) + "&via=artsy", true, true)) + " target=\"_blank\" class=\"share-to-twitter black-tooltip\"><i class=\"icon-twitter\"></i></a>");
};
jade_mixins["article-figure"] = jade_interp = function(article, width, showDate, showShare){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if ( article.get('thumbnail_image') && article.get('thumbnail_image').url)
{
var imgUrl = article.get('thumbnail_image').url
}
else
{
var imgUrl = article.cropUrlFor('thumbnail_image', { width: width, height: Math.round(width / 1.5) })
}
buf.push("<figure class=\"article-figure\"><div class=\"article-figure-container\"><a" + (jade.attr("href", article.href(), true, true)) + " class=\"article-figure-img-container\"><div" + (jade.attr("style", "background-image: url(" + (imgUrl) + ")", true, true)) + " class=\"article-figure-img\"></div></a><figcaption class=\"article-figure-figcaption\">");
if ( showDate)
{
buf.push("<time class=\"article-figure-date\">" + (jade.escape(null == (jade_interp = article.formatDate()) ? "" : jade_interp)) + "</time>");
}
buf.push("<a" + (jade.attr("href", article.href(), true, true)) + " class=\"article-figure-title\">" + (jade.escape(null == (jade_interp = article.get('thumbnail_title')) ? "" : jade_interp)) + "</a><div class=\"article-figure-author-section\">");
if ( article.get('contributing_authors') && article.get('contributing_authors').length === 0 || article.get('channel_id') !== sd.ARTSY_EDITORIAL_CHANNEL || sd.CURRENT_PATH !== '/articles')
{
buf.push("<div" + (jade.cls(['article-figure-author',article.get('contributing_authors') && article.get('contributing_authors').length > 0 ? 'has-contributing-author' : ''], [null,true])) + ">" + (jade.escape(null == (jade_interp = article.get('author') ? article.get('author').name : '') ? "" : jade_interp)) + "</div>");
}
if ( article.get('contributing_authors') && article.get('contributing_authors').length > 0)
{
buf.push("<div class=\"article-figure-contributing-name\">" + (jade.escape(null == (jade_interp = "By " + article.byline()) ? "" : jade_interp)) + "</div>");
}
buf.push("</div>");
if ( showShare)
{
buf.push("<div class=\"article-figure-share js-article-figure-share\">");
jade_mixins["share"](
            (article.get('share_description') || article.get('thumbnail_title')),
            article.get('thumbnail_image'),
            (sd && sd.APP_URL) + article.href()
          );
buf.push("</div>");
}
buf.push("</figcaption></div></figure>");
};
jade_mixins["article-figure"](article, (article.isTopTier() ? 600 : 400), true, true);}.call(this,"Math" in locals_for_with?locals_for_with.Math:typeof Math!=="undefined"?Math:undefined,"article" in locals_for_with?locals_for_with.article:typeof article!=="undefined"?article:undefined,"encodeURIComponent" in locals_for_with?locals_for_with.encodeURIComponent:typeof encodeURIComponent!=="undefined"?encodeURIComponent:undefined,"sd" in locals_for_with?locals_for_with.sd:typeof sd!=="undefined"?sd:undefined));;return buf.join("");
};
module.exports = template;